export default {
    cz: {
        hasVariants: 'Více variant',
        hasGift: 'Dárek k nákupu',
        hasPpl: 'Doprava PPL',
    },
    sk: {
        hasVariants: 'Viac variantov',
        hasGift: 'Darček na nákup',
        hasPpl: 'Doprava PPL',
    },
}
